import { cn, Text } from '@vidahealth/vida-ui';
import { Pressable, ScrollView } from 'react-native';

import type { AvailabilityDay } from '../utils/groupTimeslots';

/** Private to CoachAvailabilityScreen — a horizontal rail of selectable days. */
export function DayRail({
  days,
  selectedKey,
  onSelect,
}: {
  days: AvailabilityDay[];
  selectedKey: string | undefined;
  onSelect: (key: string) => void;
}) {
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={{ gap: 12, paddingVertical: 4 }}
    >
      {days.map((day) => {
        const isSelected = day.key === selectedKey;
        return (
          <Pressable
            key={day.key}
            accessibilityRole='button'
            accessibilityState={{ selected: isSelected }}
            onPress={() => onSelect(day.key)}
            testID={`coach-availability-day-${day.key}`}
            className={cn(
              'min-w-[120px] items-start rounded-sm border bg-background-0 px-4 py-3',
              isSelected ? 'border-2 border-primary-500' : 'border-outline-100'
            )}
          >
            <Text size='md' className='font-body-semibold text-typography-900'>
              {day.dayLabel}
            </Text>
            <Text size='sm' className='font-body text-typography-600'>
              {day.dateLabel}
            </Text>
          </Pressable>
        );
      })}
    </ScrollView>
  );
}
